<div class="container pt-3">
  <rbb-side-menu-headline headline="Datenschutzbeauftragte" icon="fas fa-user-shield"/>

  @if (forms) {
    <rbb-table [responsiveBreakpoint]="'lg'" [columns]="columns" [values]="forms" [pageSizes]="[20]" [search]="true"
               searchType="GENERAL" [tableData]="tableData" trClass="pointer" (trClick)="openForm($event)"/>
    <ng-template let-column="column" let-value="value" #tableData>
      <td>
        @switch (column.field) {
          @case ('name') {
            <span class="fw-bold">{{value[column.field]}}</span>
          }
          @case ('createdByLastName') {
            {{value.createdByFirstName}} {{value.createdByLastName}}
          }
          @case ('approvalDataProtectionOfficer') {
            @if (value[column.field] === 'PENDING') {
              <span class="text-secondary">Warte auf Freigabe</span>
            }
          }
          @default {
            {{ value[column.field] }}
          }
        }
      </td>
    </ng-template>
  } @else {
    <div class="text-center m-auto mt-5">
      <rbb-loader/>
      <small class="text-secondary d-block">Formulare werden geladen...</small>
    </div>
  }


</div>

